import React from 'react';
import { Stack, Text, Button, ScrollArea, Badge, ActionIcon } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useSendNotification } from '../../../../hooks/notifications/useSendNotification.jsx';
import { useUIEnhancements } from '../../../../hooks/ui/useUIEnhancements';

const NotificationDrawer = ({ onClose }) => {
  const { notifications } = useSendNotification();
  const { sanitizeContent } = useUIEnhancements();

  return (
    <Stack spacing="md" h="100%">
      <ScrollArea style={{ height: 'calc(100% - 60px)' }}>
        {notifications.length === 0 ? (
          <Text align="center" color="dimmed" mt="xl">No notifications</Text>
        ) : (
          notifications.map((notification) => (
            <Stack key={notification.id} p="md" spacing="xs" style={{ borderBottom: '1px solid #eee' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Badge color="blue" size="sm">
                  {notification.status}
                </Badge>
                <Text size="xs" color="dimmed">{new Date(notification.createdAt?.toDate()).toLocaleString()}</Text>
              </div>
              <Text weight={500}>{sanitizeContent(notification.title)}</Text>
              <Text size="sm">{sanitizeContent(notification.body)}</Text>
            </Stack>
          ))
        )}
      </ScrollArea>
      <ActionIcon
        style={{ position: 'absolute', top: 10, right: 10 }}
        onClick={onClose}
      >
        <IconX size={18} />
      </ActionIcon>
    </Stack>
  );
};

export default NotificationDrawer;
